import { Gutenberg } from './types_and_parser/types.ext.gen'
import { Block } from './types_and_parser/standard_blocks.gen'
import { BlockData } from '../cms/blocks/types.gen'
import { Option, none } from 'widgets-for-react'
import { ExtraImages } from '../public_site/utils/extra_images.mod'


export const TransformStandardBlock = (b: Gutenberg.Block): Block => {
  return { ...b, kind: b.blockName } as Block
}

export const WordPressBlock_To_WidgetBlock = <CustomBlockData, CustomBlocks extends { kind: CustomBlocks['kind'] }, CustomPageData>(
  block: Block,
  index: number,
  extra_data: CustomPageData,
  mk_block?: (block: CustomBlocks, block_index: number, extra_data: CustomPageData) => Option<CustomBlockData>
): Option<BlockData<CustomBlockData, ExtraImages> | CustomBlockData> => {
  if (mk_block) {
    let maybe_res = mk_block(block as any, index, extra_data)
    if (maybe_res.v.kind == 'r') return maybe_res
  }
  switch (block.kind) {
    // case 'vidda/cta':
    //   return some<BlockData<CustomBlockData, ExtraImages>>(ctaBlock(block))
    // case 'vidda/text':
    //   return some<BlockData<CustomBlockData, ExtraImages>>(textBlock(block))
    // case 'vidda/download':
    //   return some<BlockData<CustomBlockData, ExtraImages>>(downloadBlock(block))
    //  case 'featured_content':
    //    return some<BlockData<CustomBlockData, ExtraImages>>(featuredContent<CustomBlockData>(block))
    //  case 'download':
    //    return some<BlockData<CustomBlockData, ExtraImages>>(downloadBlock(block))
    // case 'vidda/link-list':
    //   return some<BlockData<CustomBlockData, ExtraImages>>(linkListBlock(block))
    //  case 'quote':
    //    return some<BlockData<CustomBlockData, ExtraImages>>(quoteBlock(block))
    //  case 'vidda/iframe':
    //  return some<BlockData<CustomBlockData, ExtraImages>>(iframeBlock(block))
    //  case 'link_grid':
    //    return some<BlockData<CustomBlockData, ExtraImages>>(linkGridBlock(block))
    //  case 'media':
    //    return some<BlockData<CustomBlockData, ExtraImages>>(mediaBlock(block))
    //  case 'vidda/expandable':
    //    return some<BlockData<CustomBlockData, ExtraImages>>(expandBlock(block, index))
    default: {
      console.warn('Unsupported block.', block)
      return none<BlockData<CustomBlockData, ExtraImages> | CustomBlockData>()
    }
  }
}

// export const featuredContent = <CustomBlocks>(block: FeaturedContentBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'featuredContentBlock',
//   value: [
//     mk_pair<FeaturedContentBlockProps<CustomBlocks, ExtraImages>, FeaturedContentBlockStyle>(
//       {
//         image: block.image,
//         imageLocation: block.image_position,
//         title: block.title,
//         intro: block.intro,
//         image_size: 'full', // TODO: what to do here?
//         image_alt_text: 'TODO: alt', // TODO: what to do with alt? Add extra field?
//         primary_button: block.primary_button
//           ? buttonWrapper({ title: block.primary_button.title, url: block.primary_button.url })
//           : null,
//         secondary_button: block.secondary_button
//           ? buttonWrapper({ title: block.secondary_button.title, url: block.secondary_button.url })
//           : null,
//         get_default_data_src: get_default_data_src,
//         get_default_data_srcset: get_default_data_srcset
//       },
//       featuredContentClasses(block.image_position)
//     )
//   ]
// })


// export const textBlock = <CustomBlocks>(block: TextBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'textBlock',
//   value: mk_pair<TextBlockProps<CustomBlocks, ExtraImages>, TextBlockStyle>(
//     {
//       title: block.attrs.title,
//       text: block.attrs.text,
//       primary_button: block.attrs.show_primary ? createButtonData(block.attrs.primary_button_text,block.attrs.primary_button_url) : null,
//       secondary_button: block.attrs.show_secondary ? createButtonData(block.attrs.secondary_button_text,block.attrs.secondary_button_url) : null,
//       has_show_more: block.attrs.has_show_more
//     },
//     textBlockClasses
//   )
// })

// export const ctaBlock = <CustomBlocks>(block: CTABlock): BlockData<CustomBlocks, ExtraImages> => ({
//          kind: 'ctaBlock',
//          value: mk_pair<CtaBlockProps, CtaBlockStyle>(
//            {
//              title: block.attrs.title,
//              intro: block.attrs.intro,
//              buttons:
//                block.attrs.primary_button_url && block.attrs.secondary_button_url
//                  ? 'primary_secondary'
//                  : block.attrs.primary_button_url
//                  ? 'primary'
//                  : 'none',
//              primary_button: block.attrs.primary_button_url
//                ? linkWrapper({ title: block.attrs.primary_button_text, url: block.attrs.primary_button_url })
//                : null,
//              secondary_button: block.attrs.secondary_button_url
//                ? linkWrapper({ title: block.attrs.secondary_button_text, url: block.attrs.secondary_button_url })
//                : null
//            },
//            ctaBlockClasses
//          )
//        })

// export const quoteBlock = <CustomBlocks>(block: QuoteBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'quoteBlock',
//   value: mk_pair<QuoteBlockProps<ExtraImages>, QuoteBlockStyle>(
//     {
//       text: block.text,
//       author: block.author,
//       link: block.button ? linkWrapper({ title: block.button.title, url: block.button.url }) : null,
//       image: block.image,
//       size: 'full',
//       // image_alt: block.field_image && block.field_image.field_media_image.alt ? block.field_image.field_media_image.alt : "",
//       get_default_data_src: get_default_data_src,
//       get_default_data_srcset: get_default_data_srcset
//     } as QuoteBlockProps<ExtraImages>,
//     quoteBlockClasses(null)
//   )
// })

// export const iframeBlock = <CustomBlocks, custom_images>(block: IframeBlock): BlockData<CustomBlocks, custom_images> => ({
//   kind: 'iframeBlock',
//   value: mk_pair<IframeBlockProps, IframeBlockStyle>(
//     {
//       link: block.attrs.url
//     },
//     iframeBlockClasses(null)
//   )
// })

// export const expandBlock = <CustomBlocks>(block: ExpandBlock, index: number): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'expandBlock',
//   value: mk_pair<ExpandBlockProps, ExpandBlockStyle>(
//     {
//       block_index: index,
//       title: block.attrs.title,
//       intro: block.attrs.intro,
//       link: block.attrs.show_button ? linkWrapper({ title: block.attrs.button_text, url: block.attrs.button_url }) : null,
//       items: block.innerBlocks
//         .map<ExpandProps>((item, i) => ({
//           key: `${i}`,
//           title: item.attrs.title,
//           text: item.innerBlocks.map(i => i.innerHTML).join(''),
//           open: false
//         })),
//     },
//     expandBlockClasses
//   )
// })

// export const linkListBlock = <CustomBlocks>(block: LinkListBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'linkBlock',
//   value: mk_pair<LinkBlockProps, Unit>(
//     {

//       title: block.attrs.title,
//       intro: block.attrs.intro,
//       primary_button: block.attrs.show_primary ? createButtonData(block.attrs.primary_button_text,block.attrs.primary_button_url) : null,
//       secondary_button: block.attrs.show_secondary ? createButtonData(block.attrs.secondary_button_text, block.attrs.secondary_button_url) : null,
//       items: block.innerBlocks.map((linkItem,index) => {
//         return {
//           key: index.toString(),
//           title: linkItem.attrs.link_text
//           target: '_self',
//           url: i.link_url
//       }))
//     },
//     linkListBlockClasses
//   )
// })

// export const downloadBlock = <CustomBlocks>(block: DownloadBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'downloadBlock',
//   value: mk_pair<DownloadBlockProps, DownloadBlockStyle>(
//     {
//       intro: 'Intro tekst',
//       title: 'Test titel',
//       items: [{file_url: '#een', title: 'Test'}]
//       // title: block.title,
//       // intro: block.intro,
//       // items: block.items.map((e, i) => ({
//       //   key: `${e.item.title}-${i}`,
//       //   title: e.item.title,
//       //   file_url: e && e.item && e.item.file && e.item.file.url
//       // }))
//     },
//     downloadBlockClasses
//   )
// })

// export const  = <CustomBlocks>(block: LinkGridBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'linkGridBlock',
//   value: mk_pair<LinkGridBlockProps<ExtraImages>, LinkGridBlockStyle>(
//     {
//       title: block.title,
//       intro: block.intro,
//       items: block.items
//         .filter(x => x)
//         .map<LinkGridItem<ExtraImages>>(item => ({
//           image: item.image,
//           image_size: 'full',
//           image_alt: item.image_alt,
//           title: item.title,
//           intro: item.intro,
//           link: item.link ? linkWrapper(item.link) : undefined,
//           show_image: block.show_image == 'yes'
//         }))linkGridBlock
//         .filter(x => x),
//       link: block.link ? linkWrapper(block.link) : undefined,
//       show_image: block.show_image == 'yes',
//       get_default_data_src: get_default_data_src,
//       get_default_data_srcset: get_default_data_srcset
//     },
//     linkGridBlockClasses(block.link ? true : false)
//   )
// })

// type PlyrType = 'youtube' | 'vimeo' | 'video' | 'audio'
// function parseVideoUrl(url: string) {
//   const id_regex = /\?v=(.*)/
//   return {
//     id: id_regex.test(url) && url.match(id_regex)[1],
//     type: /youtube/.test(url) ? 'youtube' : /vimeo/.test(url) ? ('vimeo' as PlyrType) : null
//   }
// }

// export const mediaBlock = <CustomBlocks>(block: MediaBlock): BlockData<CustomBlocks, ExtraImages> => ({
//   kind: 'mediaBlock',
//   value: mk_pair<MediaBlockProps<ExtraImages>, MediaBlockStyle>(
//     {
//       kind_media: block.attrs.type,
//       caption: block.attrs.caption,
//       image: block.attrs.type == 'image' ? block.attrs.image : undefined,
//       image_alt: block.attrs.type == 'image' ? block.attrs.image.alt_text : '',
//       size: 'full',
//       get_default_data_src: get_default_data_src,
//       get_default_data_srcset: get_default_data_srcset,
//       video: block.attrs.type == 'video' && {
//         url: block.attrs.video.video_url ? block.attrs.video.video_url : undefined,
//         id: block.attrs.video ? block.attrs.video.video_id : undefined,
//         type: block.attrs.video.video_type ? block.attrs.video.video_type : undefined,
//         allowFullScreen: true,
//         frameBorder: '0',
//         width: '100%',
//         height: '400'
//       },
//       useCookieBar: false
//     },
//     mediaBlockClasses(block.attrs.type)
//   )
// })
